import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './Redux/store';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <BrowserRouter>
 <Provider store = {store}>
   <BrowserRouter>
    <App />
    </BrowserRouter>
  </Provider>
  </BrowserRouter>
 ,
  document.getElementById('root')
);


